var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.94,
    height: 27.59,
    viewBox: "0 0 27.94 27.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.98,0S2.74,7.87,11.63,16.96c-.76-.77-1.08-2.18-1.16-3.21-.07-.94.05-1.88.34-2.78.18-.56.42-1.11.7-1.63.31-.56,1.2-1.78,1.2-1.78,0,0,.17,1.42.36,1.92s.45,1.3.88,1.83c.75.92,1.89,1.58,2.27,2.7.24.71.12,1.49-.1,2.2-.3.99-.81,1.86-1.42,2.68,1.46-.83,2.85-1.89,3.96-3.16.99-1.13,1.81-2.52,1.81-4.06,0-4.12-3.91-5.26-3.61-7.86.3-2.61,1.12-3.83,1.12-3.83Z",
    fill: "#b83534",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.11,20.16c.06.14.47,1,.93,2.12h9.84c.46-1.12.87-1.99.93-2.12h-11.71Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.41,3.89H0v.73h10.75c.21-.24.43-.49.66-.73Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.16,
    width: 6.7,
    height: 2.12,
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.95,24.77c.24-.72.52-1.46.79-2.13h-9.56c.27.67.55,1.41.79,2.13h7.97Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.41,15.55H0v1.78h10.82c-.55-.58-1.02-1.18-1.41-1.78Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.64,
    width: 6.7,
    height: 2.13,
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.59,8.1H0v1.45h8.16c.1-.48.24-.97.43-1.45Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.97,5.61H0v1.45h9.06c.26-.49.56-.97.91-1.45Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.02,10.58H0v1.45h8.06c-.06-.48-.08-.97-.05-1.45Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.27,13.07H0v1.45h8.83c-.23-.48-.42-.96-.55-1.45Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.41,18.04H0v1.78h13.55c-1.3-.93-2.14-1.78-2.14-1.78Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.97,9.55h6.97v-1.45h-7.66c.27.44.51.92.69,1.45Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.31,11.69c0,.12,0,.23-.01.35h6.63v-1.45h-6.71c.06.35.09.72.09,1.11Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.97,6.37c.18.22.38.45.57.69h8.4v-1.45h-9.59c.18.23.38.48.62.76Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.56,14.52h7.38v-1.45h-6.8c-.13.48-.32.97-.58,1.45Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.71,3.89s0,.02,0,.03c-.03.24,0,.47.07.69h10.16v-.73h-10.23Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.24,
    y: 20.16,
    width: 6.7,
    height: 2.12,
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.33,27.59c0-.63.22-1.54.52-2.49h-7.76c.3.96.52,1.86.52,2.49",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.94 27.59 27.94 25.1 21.24 25.1 21.24 27.59",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.7 27.59 6.7 25.1 0 25.1 0 27.59",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.29,16.31c-.31.35-.64.69-1,1.02h9.64v-1.78h-8.03c-.19.25-.39.51-.61.76Z",
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.24,
    y: 22.64,
    width: 6.7,
    height: 2.13,
    fill: "#323986",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.11,19.65l-.3.17h13.12v-1.78h-10.46c-.72.58-1.52,1.13-2.36,1.6Z",
    fill: "#323986",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.81bab075f1101983934ce50a08aeb4fd.svg";
export { ForwardRef as ReactComponent };